module.exports = __webpack_public_path__ + "img/bg1.792096cc.jpg";